import STORES from 'data/dummy/stores'

export const STORE_A = STORES[0]
export const STORE_B = STORES[1]
